import React from 'react'
import { Alert, Button } from 'antd'
import './StatusAlert.scss'

/**
 * A reusable component for displaying status alerts (impersonation, developer mode, etc.)
 * @param {Object} props Component props
 * @param {string} props.message The message to display in the alert
 * @param {string} props.type The type of alert ('impersonation' or 'developer')
 * @param {Function} [props.onAction] Optional callback for the action button
 * @param {string} [props.actionText] Optional text for the action button
 */
const StatusAlert = ({ message, type, onAction, actionText }) => {
    return (
        <div className={`status-alert-wrapper ${type}`}>
            <Alert
                banner
                className='status-alert'
                message={
                    <div className='status-alert-content'>
                        <span className='alert-text'>{message}</span>
                        {onAction && actionText && (
                            <Button size='small' onClick={onAction}>
                                {actionText}
                            </Button>
                        )}
                    </div>
                }
                showIcon={false}
            />
        </div>
    )
}

export default StatusAlert
